export const Events = {
  CONVERSION_MADE: 'conversion_made',
  CONVERTER_CLICK: 'converter_click',
  RESULT_COPY: 'result_copy',
  RESULT_SHARE: 'result_share',
  LANGUAGE_SWITCH: 'language_switch',
  COOKIE_ACCEPT: 'cookie_accept',
  COOKIE_REJECT: 'cookie_reject'
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  } else {
    // Analytics not loaded or blocked, ignore gracefully
    console.debug(`Event tracked: ${eventName}`, params);
  }
};